import React, { useState } from 'react'
import { Button, Modal } from '@material-ui/core'
import { useTheme } from "@material-ui/core/styles"
import { useTranslation } from 'react-i18next'
import { JsonEditor } from 'jsoneditor-react'
import './style.css'
import 'jsoneditor-react/es/editor.min.css'
import ace from 'brace'
import 'brace/theme/github'
import 'brace/mode/json'
import { convertJSONToObject } from '../../../../../utils'


const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80vw',
    height: '80vh',
    backgroundColor: '#fff',
    padding: '20px',
    outline: 'none',
    borderRadius: '8px',
    display: 'flex',
    flexDirection: 'column',
}


const JsonEditorModal = ({ open, onClose, onSave, value, title }) => {
    const { theme: { bgColors, colors } } = useTheme()
    const { t } = useTranslation()
    const [json, setJson] = useState(value)
    const [buttonDisabled, setButtonDisabled] = useState(true)
    const defaultValue = convertJSONToObject(json, value)

    const handleValidationError = (error) => {
        if (error.length > 0) {
            setButtonDisabled(true)
        }
    }
    const handleChange = (newJson) => {
        setJson(JSON.stringify(newJson))
        setButtonDisabled(false)
    }
    const handleSave = () => {
        try {
            onSave(json)
            onClose()
        } catch (error) {
            setButtonDisabled(true)
        }
    }
    return (
        <Modal open={open} onClose={onClose}  >
            <div style={modalStyle}>
    <h4>{t('edit')} {t(title)}</h4>
    <div style={{ flex: 1, overflow: 'hidden' }}>
        <JsonEditor
            value={defaultValue}
            onChange={handleChange}
            mode="code"
            ace={ace}
            search={true}
            onValidationError={handleValidationError}
            htmlElementProps={{ style: { height: '60vh', width: '100%' } }}
        />
    </div>
    <div className="d-flex justify-content-end mt-3">
        <Button
            type="submit"
            variant="contained"
            color="primary"
            style={{ backgroundColor: bgColors.bgBlue1000, color: colors.colorPrimary0 }}
            className="mr-2"
            onClick={onClose}
        >
            {t('close')}
        </Button>
        <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={buttonDisabled}
            style={{ backgroundColor: buttonDisabled ? bgColors.bgBlue300 : bgColors.bgBlue1000, color: colors.colorPrimary0 }}
            className="mr-2"
            onClick={handleSave}
        >
            {t('save')}
        </Button>
    </div>
</div>
        </Modal>
    )
}

export default JsonEditorModal
